import DpitColor from './DpitColor';

export default class DpitColorWithHslFeatures extends DpitColor {
	lightness() {

		const r = this.rgbObj.r / 255;
		const g = this.rgbObj.g / 255;
		const b = this.rgbObj.b / 255;

		const max = Math.max(r, g, b);
		const min = Math.min(r, g, b);
		return (max + min) / 2;
	}

	toHslObj() {
		const r = this.rgbObj.r / 255;
		const g = this.rgbObj.g / 255;
		const b = this.rgbObj.b / 255;

		const max = Math.max(r, g, b);
		const min = Math.min(r, g, b);
		let h, s, l = (max + min) / 2;

		if (max === min) {
			h = s = 0; // achromatic
		} else {
			const d = max - min;
			s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

			switch (max) {
				case r:
					h = (g - b) / d + (g < b ? 6 : 0);
					break;
				case g:
					h = (b - r) / d + 2;
					break;
				case b:
					h = (r - g) / d + 4;
					break;
			}

			h /= 6;
		}

		return { h, s, l };
	}

	static fromHslObj(hslObj) {
		let r, g, b;
		const { h, s, l } = hslObj;
		if (s === 0) {
			r = g = b = l; // achromatic
		} else {
			const hueToRgb = (p, q, t) => {
				if (t < 0) t += 1;
				if (t > 1) t -= 1;
				if (t < 1 / 6) return p + (q - p) * 6 * t;
				if (t < 1 / 2) return q;
				if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
				return p;
			};

			const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
			const p = 2 * l - q;

			r = hueToRgb(p, q, h + 1 / 3);
			g = hueToRgb(p, q, h);
			b = hueToRgb(p, q, h - 1 / 3);
		}

		return new DpitColorWithHslFeatures({
			r: Math.round(r * 255),
			g: Math.round(g * 255),
			b: Math.round(b * 255)
		});
	}

	setLightness(lightnessVal) {
		const hslObj = this.toHslObj();
		hslObj.l = lightnessVal;
		return DpitColorWithHslFeatures.fromHslObj(hslObj);

	}

}
